import { render, staticRenderFns } from "./LogoDisplayer.vue?vue&type=template&id=9f9e2e3a"
import script from "./LogoDisplayer.vue?vue&type=script&lang=js"
export * from "./LogoDisplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports